"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SyncProgressItem = exports.MinimizedProgress = exports.ImportingNotices = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _clamp = _interopRequireDefault(require("lodash/clamp"));
var _rangeRight = _interopRequireDefault(require("lodash/rangeRight"));
var _reactSpring = require("react-spring");
var _reactI18next = require("react-i18next");
var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));
var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));
var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));
var _Image = _interopRequireWildcard(require("../Image"));
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _Button = _interopRequireDefault(require("../Button"));
var _styles = require("@material-ui/core/styles");
var _excluded = ["isError", "isPaused", "errorMessage", "name", "email", "logo"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SyncProgress = function SyncProgress(_ref) {
  var _ref$emails = _ref.emails,
    emails = _ref$emails === void 0 ? [] : _ref$emails,
    onBack = _ref.onBack,
    onContinue = _ref.onContinue,
    children = _ref.children;
  var ref = (0, _react.useRef)(null);
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    shadow = _useState2[0],
    setShadow = _useState2[1];
  (0, _react.useEffect)(function () {
    function handleOnScroll() {
      var target = ref.current;
      if (target) {
        var clientHeight = target.clientHeight,
          scrollHeight = target.scrollHeight,
          scrollTop = target.scrollTop;
        if (scrollTop + clientHeight < scrollHeight) {
          setShadow(true);
          return;
        }
      }
      setShadow(false);
    }
    if (ref.current) {
      ref.current.addEventListener('scroll', handleOnScroll);
      window.addEventListener('resize', handleOnScroll);
      handleOnScroll();
    }
    return function () {
      if (ref.current) {
        ref.current.removeEventListener('scroll', handleOnScroll);
        window.removeEventListener('resize', handleOnScroll);
      }
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: "h-full overflow-auto"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-24 px-32"
  }, /*#__PURE__*/_react["default"].createElement(Back, {
    onClick: onBack
  }), /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    alt: "OnMail",
    className: "w-32",
    src: (0, _Image.withThemeSrc)(t('onmail.png'), t('onmail-light.png'))
  }), /*#__PURE__*/_react["default"].createElement("h2", {
    className: "text-4xl font-bold text-dark my-2"
  }, t('retrofit.syncProgress.header', {
    count: emails.length,
    email: emails[0]
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-lg text-light font-light mb-5"
  }, t('retrofit.syncProgress.description')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-6"
  }, children)), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('py-4 px-32 sticky bottom-0 bg-app', {
      'shadow-hover': shadow
    })
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "w-64",
    onClick: onContinue
  }, t('button.continue'))));
};
var SyncProgressItem = exports.SyncProgressItem = function SyncProgressItem(_ref2) {
  var _ref2$isError = _ref2.isError,
    isError = _ref2$isError === void 0 ? false : _ref2$isError,
    _ref2$isPaused = _ref2.isPaused,
    isPaused = _ref2$isPaused === void 0 ? false : _ref2$isPaused,
    errorMessage = _ref2.errorMessage,
    name = _ref2.name,
    email = _ref2.email,
    logo = _ref2.logo,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var progress = (0, _clamp["default"])(props.progress, 0, 100);
  var marginLeft = (0, _rangeRight["default"])(-60, 10.1, 0.7)[progress];

  // EWM-3143 Should show the error event full-sync
  var shouldError = isError;
  var shouldPause = isPaused && progress !== 100;
  var animated = (0, _reactSpring.useSpring)({
    progress: progress,
    marginLeft: marginLeft
  });
  function renderProgress() {
    if (shouldError) {
      return /*#__PURE__*/_react["default"].createElement(ErrorProgress, {
        value: 0,
        variant: "determinate"
      });
    } else {
      return /*#__PURE__*/_react["default"].createElement(Progress, {
        value: progress,
        variant: "determinate",
        color: shouldPause ? 'secondary' : 'primary'
      });
    }
  }
  function renderErrorText() {
    return /*#__PURE__*/_react["default"].createElement(StyledTooltip, {
      title: errorMessage || t('retrofit.syncProgress.tooltip.error')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "absolute top-0 left-0 flex items-center h-full w-full"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold text-white px-4 cursor-default"
    }, "Error", /*#__PURE__*/_react["default"].createElement(_Error["default"], {
      fontSize: "inherit",
      className: "ml-1"
    }))));
  }
  function renderText() {
    return /*#__PURE__*/_react["default"].createElement(_reactSpring.a.div, {
      className: "absolute top-0 left-0 flex items-center w-full h-full",
      style: {
        transformOrigin: 'left',
        transform: "translateX(".concat(progress - 100, "%)"),
        // Taken from linear progress bar's transition styling
        transition: 'transform 0.4s linear'
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold w-full text-right",
      style: {
        marginLeft: "".concat(100 - progress, "%")
      }
    }, shouldPause ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-gray-light px-4"
    }, "Paused") : /*#__PURE__*/_react["default"].createElement(_reactSpring.a.span, {
      className: "text-white px-4"
    }, animated.progress.interpolate(function (x) {
      return x.toFixed(0) + '%';
    }))));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex py-3 items-center"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: logo,
    alt: logo,
    className: "w-auto h-12 rounded-full mr-3"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-1/4"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-dark font-bold truncate"
  }, name), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-light truncate"
  }, email)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 ml-5 relative"
  }, renderProgress(), shouldError ? renderErrorText() : renderText()), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-14 px-4 text-primary"
  }, !shouldError && progress === 100 && /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], null)));
};
var MinimizedProgress = exports.MinimizedProgress = function MinimizedProgress(_ref3) {
  var _ref3$isError = _ref3.isError,
    isError = _ref3$isError === void 0 ? false : _ref3$isError,
    _ref3$isPaused = _ref3.isPaused,
    isPaused = _ref3$isPaused === void 0 ? false : _ref3$isPaused,
    errorMessage = _ref3.errorMessage,
    progress = _ref3.progress,
    logos = _ref3.logos,
    onClick = _ref3.onClick,
    onImport = _ref3.onImport;
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;

  // EWM-3143 Should show the error event full-sync
  var shouldError = isError;
  var shouldPaused = isPaused && progress !== 100;
  function renderProgress() {
    if (shouldError) {
      return /*#__PURE__*/_react["default"].createElement(MiniErrorProgress, {
        variant: "determinate",
        value: 0
      });
    } else {
      return /*#__PURE__*/_react["default"].createElement(MiniProgress, {
        variant: "determinate",
        value: (0, _clamp["default"])(progress, 0, 100),
        color: shouldPaused ? 'secondary' : 'primary'
      });
    }
  }
  function renderText() {
    if (shouldError) {
      return /*#__PURE__*/_react["default"].createElement(StyledTooltip, {
        title: errorMessage || t('retrofit.syncProgress.tooltip.error')
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-white dark:text-gray-medium flex items-center"
      }, "Error"));
    } else if (shouldPaused) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-gray-light dark:text-gray-medium"
      }, "Paused");
    } else {
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])({
          'text-white dark:text-gray-medium': progress >= 45,
          'text-primary dark:text-gray-medium': progress < 45
        })
      }, progress < 100 ? "".concat(progress, "%") : 'Done!');
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-3 px-5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cursor-pointer w-full",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-between mb-3"
  }, /*#__PURE__*/_react["default"].createElement("h5", {
    className: "font-bold"
  }, t('retrofit.syncProgress.minimized.header')), logos), /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, renderProgress(), /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute top-0 left-0 flex items-center justify-center h-full w-full"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm font-bold"
  }, renderText())))), /*#__PURE__*/_react["default"].createElement("p", {
    className: "mt-3 text-primary cursor-pointer font-bold text-sm",
    onClick: onImport
  }, t('retrofit.syncProgress.minimized.importAnother')));
};
var Back = function Back(props) {
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "w-16 h-16 absolute mt-4 ml-4 top-0 left-0 shadow-lg flex items-center justify-center rounded-full cursor-pointer"
  }, props), /*#__PURE__*/_react["default"].createElement(_ArrowBack["default"], null));
};
var Progress = (0, _styles.withStyles)(function (_ref4) {
  var palette = _ref4.palette;
  return {
    root: {
      height: 45
    },
    barColorSecondary: {
      backgroundColor: 'var(--color-divider)'
    },
    colorPrimary: {
      // TODO: Temporary color for gray
      backgroundColor: palette.grey[palette.type === 'light' ? 100 : 800]
    },
    colorSecondary: {
      // TODO: Temporary color for gray
      backgroundColor: palette.grey[palette.type === 'light' ? 100 : 800]
    }
  };
})(_LinearProgress["default"]);
var ErrorProgress = (0, _styles.withStyles)(function (_ref5) {
  var palette = _ref5.palette;
  return {
    root: {
      height: 45
    },
    colorPrimary: {
      backgroundColor: palette.error.main,
      opacity: 0.5
    }
  };
})(_LinearProgress["default"]);
var MiniProgress = (0, _styles.withStyles)(function (_ref6) {
  var palette = _ref6.palette;
  return {
    root: {
      height: 20
    },
    barColorSecondary: {
      backgroundColor: 'var(--color-divider)'
    },
    colorPrimary: {
      // TODO: Temporary color for gray
      backgroundColor: palette.grey[palette.type === 'light' ? 100 : 700]
    },
    colorSecondary: {
      // TODO: Temporary color for gray
      backgroundColor: palette.grey[palette.type === 'light' ? 100 : 700]
    }
  };
})(_LinearProgress["default"]);
var MiniErrorProgress = (0, _styles.withStyles)(function (_ref7) {
  var palette = _ref7.palette;
  return {
    root: {
      height: 20
    },
    colorPrimary: {
      backgroundColor: palette.error.main,
      opacity: 0.5
    }
  };
})(_LinearProgress["default"]);
var StyledTooltip = (0, _styles.withStyles)(function (_ref8) {
  var palette = _ref8.palette,
    shadows = _ref8.shadows;
  return {
    tooltip: {
      background: 'var(--color-bg-card)',
      fontSize: '0.75rem',
      padding: '0.75rem 1rem',
      color: palette.text.secondary,
      boxShadow: shadows[2]
    }
  };
})(_Tooltip["default"]);
var _default = exports["default"] = SyncProgress;
var ImportingNotices = exports.ImportingNotices = function ImportingNotices(_ref9) {
  var _ref9$className = _ref9.className,
    className = _ref9$className === void 0 ? '' : _ref9$className;
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation4.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('italic text-light font-light', className)
  }, t('retrofit.syncProgress.notices'));
};
//# sourceMappingURL=SyncProgress.js.map